/* VERO LUX — subtle haptic taps on touch devices (Android: Vibration API; iOS 18+: native switch haptic). */
(function () {
  var d = document, w = window;
  if (!w.matchMedia || !w.matchMedia('(pointer: coarse)').matches) return;
  var canVibrate = typeof navigator.vibrate === 'function';
  var wrap = null, label = null;

  function iosTap() {
    if (!label) {
      wrap = d.createElement('div');
      wrap.id = 'lx-hap';
      wrap.setAttribute('aria-hidden', 'true');
      wrap.style.cssText = 'position:fixed;left:-9999px;top:0;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none';
      var input = d.createElement('input');
      input.type = 'checkbox'; input.id = 'lx-hap-sw'; input.tabIndex = -1; input.setAttribute('switch', '');
      label = d.createElement('label'); label.htmlFor = 'lx-hap-sw';
      wrap.appendChild(input); wrap.appendChild(label); d.body.appendChild(wrap);
    }
    label.click();
  }

  var last = 0;
  function tap(strong) {
    var now = Date.now(); if (now - last < 60) return; last = now;
    try { if (canVibrate) navigator.vibrate(strong ? [12, 45, 14] : 9); else iosTap(); } catch (e) {}
  }

  /* strong: buying actions — light: choosing / opening / navigating */
  var STRONG = '.product-form__submit, .shopify-payment-button__button, [class^="ai-premium-product-sales__cta"], .vero-faq__purchase-button';
  var LIGHT = '.vero-package-option, .vbx__row, .vero-faq__question, .vero-review-card, .vero-reviews__arrow, .vps__tab, .vps__arrow, ' +
    '.vero-ritual__dot, .vero-lab__report-card, .vero-lab-modal__zoom-button, .slider-button, .vgp-card, .vhv__scroll, ' +
    '[class^="vero-polyphenol-link"], [class^="ai-hero-banner__button"], .vero-faq__whatsapp, .product__view-details, ' +
    '.vero-review-modal__close, .vero-lab-modal__close, .header__icon--menu, .header__icon--cart';

  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || t.closest('#lx-hap')) return;
    if (t.closest(STRONG)) tap(true);
    else if (t.closest(LIGHT)) tap(false);
  }, true);
})();
